export default __webpack_public_path__ + "static/media/christmasLogo.de23e220.png";